import { render, staticRenderFns } from "./WorkstyleEditer.vue?vue&type=template&id=5a4d09b2&scoped=true&"
import script from "./WorkstyleEditer.vue?vue&type=script&lang=ts&"
export * from "./WorkstyleEditer.vue?vue&type=script&lang=ts&"
import style0 from "./WorkstyleEditer.vue?vue&type=style&index=0&id=5a4d09b2&lang=scss&scoped=true&"
import style1 from "./WorkstyleEditer.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4d09b2",
  null
  
)

export default component.exports